import useApi from '../../../services/useApi'

const useGetBrandsDropdown = (id: string) => {
  const Api = useApi()
  const {data: response, isFetching} = Api.useGetQuery('/products/product-badges/all-brands/dropdown', {
    filters: {
      badge_id: id,
      page:1,
      limit:1000,
    },
  })

  return {
    allBrands: response?.data || [],
    isLoading: isFetching,
  }
}

export default useGetBrandsDropdown
